/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-03-06 14:46:03
 */
import React from 'react'
import { Tooltip } from 'antd'

export default ({ children, title = '请先选择照片' }) => {
  return (
    <Tooltip placement="top" title={title}>
      {children}
    </Tooltip>
  )
}
